@let gridData = $gridData();
@let T = gridData.data;

<unity-grid-shared
  gridTitle="Agreements"
  [gridData]="gridData"
  [gridError]="$gridError()"
  [gridLoading]="$gridLoading()"
  (dataQueryEvent)="onDataQuery($event)">
  <kendo-grid-column field="name" title="Name">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      <unity-link-gridcell-shared [displayText]="item.name" [link]="['/agreement', item.id]" />
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="current_state.name" title="Status">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      <unity-chip-workflow-state-shared [name]="item.current_state.name" [value]="item.current_state.enum_value" />
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="agency.name" title="Business Partner">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      <unity-link-gridcell-shared [displayText]="item.agency.name" [link]="['/business-partner', item.agency.id]" />
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="program.name" title="Program">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      <unity-link-gridcell-shared [displayText]="item.program.name" [link]="['/program', item.program.id]" />
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="award_amount" title="Award Amount" filter="numeric">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      {{ item.award_amount | currency: 'USD' : 'symbol' }}
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="communities" title="Communities" [filterable]="false">
    <ng-template let-agreement kendoGridCellTemplate [unityTyped]="T">
      <kendo-chiplist>
        @for (community of agreement.communities; track community.id) {
          <kendo-chip [label]="community.name" />
        }
      </kendo-chiplist>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="agreement_date" title="Agreement Date" filter="date">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      {{ item.agreement_date | dateTimezone }}
    </ng-template>
  </kendo-grid-column>
</unity-grid-shared>
